module.exports = __webpack_public_path__ + "img/travel-light.1246b4bf.png";